import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class BudgetTransaction  {
    _originalTypeClassName = "zERP.BO.BudgetTransaction";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
BudgetTransaction.translate = translateService;
}
this.Budget = new Domain.Budget();
this.Details = [];
this.Id = null;
this.CreatedAt = null;
this.Description = null;
this.DocumentId = null;
this.DocumentType = null;
this.CreatedDay = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
CreatedAt:any;
Description:any;
DocumentId:any;
DocumentType:any;
CreatedDay:any;
Budget:any;
Details:any;
TransactionEntity:any;
static setBudget = ($this, value) => {
var oldValue = $this.Budget;
$this.Budget = value;
if (value != null) {
}
}
static setDetails = ($this, items) => {
                if (items == null) items = [];
                if ($this.Details == null) $this.Details = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Details.length > 0) {
                    Domain.BudgetTransaction.removeDetails($this, $this.Details[0]);
                }

                Domain.BudgetTransaction.addManyDetails($this, copyItems);
            }
static addManyDetails = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.BudgetTransaction.addDetails($this, items[i]);
                }
            }
static addDetails = ($this, item) => {
                if ($this.Details == null) $this.Details = [];
                if (item == null || $this.Details.indexOf(item) > -1) return;
                $this.Details.push(item);
}
static addRangeDetails = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.BudgetTransaction.addDetails($this, item));
            }
static removeDetails = ($this, item) => {
                if ($this == null || $this.Details == null || $this.Details.indexOf(item) === -1) return;
                var _index = $this.Details.indexOf(item);
                $this.Details.splice(_index, 1);
}
static clearDetails = ($this) => { $this.Details = null; }
static setTransactionEntity = ($this, value) => {
var oldValue = $this.TransactionEntity;
$this.TransactionEntity = value;
if (value != null) {
}
}

static GetCreatedDay($this: any): any{if ($this?.CreatedAt == null) {return null;}
return moment([moment($this?.CreatedAt).year(), ((moment($this?.CreatedAt).month() + 1)) - 1, moment($this?.CreatedAt).date(), 12, 0, 0]).toDate();
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}